// extracted by mini-css-extract-plugin
export default {"button":"BadgeEditor_button__SB6Lz","custom":"BadgeEditor_custom__YMvR5"};